import PillowsSection from './PillowsSection';

export default PillowsSection;
